<span class="new-label discount-label" v-if="product.discount_percentage">-{{ product.discount_percentage }}%</span>